const addToOptionsMap = (optionsMap, value) => {
  // eslint-disable-next-line no-param-reassign
  optionsMap[value] = optionsMap[value] ? optionsMap[value] + 1 : 1;
};

export const getTableOptions = (data, dataField) => {
  const optionsMap = {};
  data?.forEach((item) => {
    if (Array.isArray(item?.[dataField])) {
      item[dataField].forEach((value) => addToOptionsMap(optionsMap, value));
    } else if (item?.[dataField]) {
      addToOptionsMap(optionsMap, item?.[dataField]);
      optionsMap[item[dataField]] = item.count;
    }
  });
  return Object.entries(optionsMap).map((entry) => ({
    label: entry[0],
    value: entry[0],
    count: entry[1],
  }));
};
